import React from 'react';
import { useParams } from 'react-router-dom';
import { SpeechStream } from '@twigeducation/speechstream';
import PropTypes from 'prop-types';
import AssetGlossaryPage from './AssetGlossaryPage';
import AssetPage from './AssetPage';
import getUser from '../../helpers/getUser';

const SpeechStreamWithStartingPoints = props => {
    const { language } = props;
    const user = getUser();
    const userRole = user.role;
    const isStudent = userRole === 'STUDENT';

    const contentLanguage = language || 'en-US';
    const languageCode = isStudent ? contentLanguage : 'en-US';

    return (
        <SpeechStream
            {...props}
            languageCode={languageCode}
            startingPoints={['termModalBody']}
            autoPlay
            showFixedToolbar
            fillColor="#0D729A"
        />
    );
};

SpeechStreamWithStartingPoints.propTypes = {
    sessionId: PropTypes.string,
    language: PropTypes.string,
};

SpeechStreamWithStartingPoints.defaultProps = {
    sessionId: undefined,
    language: 'en-US',
};

const AssetPageRedirect = props => {
    const { type } = useParams();
    if (type === 'glossary-term') return <AssetGlossaryPage {...props} SpeechStream={SpeechStreamWithStartingPoints} />;
    return <AssetPage {...props} />;
};

export default AssetPageRedirect;
